import PropTypes from 'prop-types'

import {Text, Flex} from '@chakra-ui/react'

const SectionTitle = ({text, children}) => {
  return (
    <Flex className="fs-unmask" justify="space-between" flexWrap="wrap">
      <Text
        as="h4"
        role="heading"
        textStyle="headline4"
        textTransform="uppercase"
        pt="xs"
        pb="sm"
      >
        {text}
      </Text>
      {children}
    </Flex>
  )
}

SectionTitle.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.node,
}

SectionTitle.defaultProps = {
  children: null,
}

export default SectionTitle
